import { render, staticRenderFns } from "./ContactEventView.vue?vue&type=template&id=1b23552f"
import script from "./ContactEventView.vue?vue&type=script&lang=js"
export * from "./ContactEventView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports